import { render, staticRenderFns } from "./Distributions.vue?vue&type=template&id=f5a2aa32&scoped=true&"
import script from "./Distributions.vue?vue&type=script&lang=js&"
export * from "./Distributions.vue?vue&type=script&lang=js&"
import style0 from "./Distributions.vue?vue&type=style&index=0&id=f5a2aa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a2aa32",
  null
  
)

export default component.exports